import GTMEvent from "@/types/GTMEvent";

/* Note events */
const category = "notes";

export const noteSubmitted = {
  category,
  name: "newNote",
  action: "submitted",
  label: "User submitted a note",
} as GTMEvent;

export const noteLiked = {
  category,
  name: "likeButton",
  action: "clicked",
  label: "User liked a note",
} as GTMEvent;

export const noteReplySubmitted = {
  category,
  name: "reply",
  action: "submitted",
  label: "User submitted a reply to a note",
} as GTMEvent;
